import classes from "./FormChoosePermitsComplete.module.css";
import { useCurrentDataContext } from "../../../contexts/CurrentDataContext";
import { useTranslation } from "react-i18next";
import { BiCheck } from "react-icons/bi";
import { FiAlertCircle } from "react-icons/fi";
import { countCompletedDemonstrations } from "../../../scripts/countCompletedDemonstrations";
import { SyntheticEvent } from "react";

interface Props {
  formSubmitHandler?: (
    e: React.SyntheticEvent<HTMLFormElement> | undefined,
    step: string
  ) => void;
  setLoading?: (val: boolean) => void;
}

const FormChoosePermitsComplete = ({
  formSubmitHandler,
  setLoading,
}: Props) => {
  const { currentData } = useCurrentDataContext();

  // Set translation
  const { t } = useTranslation();

  const handleSubmit = () => {
    setLoading && setLoading(true);
    // Call for form submitHandler, which updates data to database
    formSubmitHandler &&
      formSubmitHandler(
        undefined as unknown as SyntheticEvent<HTMLFormElement>,
        "permits"
      );
  };

  return (
    <div className={classes.formChoosePermitsCompleteContainer}>
      <div className={classes.formChoosePermitsCompleteEditRow}>
        <div className={classes.formChoosePermitsCompleteTitle}>
          {`2 ${t("formChoosePermits.mainTitle")}`}
        </div>
        {currentData?.formStatus !== "waiting" && (
          <button
            className={classes.formChoosePermitsCompleteEditButton}
            onClick={() => {
              handleSubmit();
            }}
          >
            {t("formChoosePermits.editButton")}
          </button>
        )}
      </div>
      {currentData?.formStatus !== "waiting" &&
        currentData?.replacePrevious !== null && (
          <div className={classes.replaceOld}>
            {currentData?.replacePrevious === true
              ? t("formChoosePermits.replacePreviousPermitsTrue")
              : t("formChoosePermits.replacePreviousPermitsFalse")}
          </div>
        )}

      {currentData?.formStatus !== "waiting" &&
        currentData?.replacePrevious === null && (
          <div className={classes.replaceOld}>
            {`${t("formChoosePermits.replacePreviousSelectMissing")}`}

            <FiAlertCircle className={classes.replacePreviousAlertIcon} />
          </div>
        )}

      <div className={classes.formChoosePermitsCompleteInnerContainer}>
        <table className={classes.table}>
          <tbody>
            <tr>
              <th className={classes.tableHeader}>
                {t("formChoosePermits.requestedPermits")}
              </th>
              <th className={classes.tableHeader}>
                {t("formChoosePermits.demonstrations_title")}
              </th>
            </tr>

            {currentData?.permits?.map((permit, i) => {
              // Calculate amount of completed demonstrations
              const completedAmount = countCompletedDemonstrations(permit);
              return permit.isChecked ? (
                <tr
                  key={i}
                  className={classes.formChoosePermitsCompletePermitRow}
                >
                  <td>
                    <div className={classes.formChoosePermitsCompletePermit}>
                      <BiCheck className={classes.checkIcon} />
                      <div>{permit.fullTitle}</div>
                    </div>
                  </td>
                  <td>
                    <div
                      className={
                        completedAmount < 3
                          ? `${classes.formChoosePermitsCompleteAmount} ${classes.alertColor}`
                          : classes.formChoosePermitsCompleteAmount
                      }
                    >
                      <div className={classes.row}>
                        {`${completedAmount} ${t(
                          "formChoosePermits.demonstrations_thisMany"
                        )}`}
                      </div>
                      {completedAmount < 3 && (
                        <div>
                          <FiAlertCircle className={classes.alertIcon} />
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ) : null;
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FormChoosePermitsComplete;
